import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  RadioQuestionModel,
  ContraventionQuestionModel,
  SelectQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { PaymentCopy } from '../../../helper/textcopy/policies.text';
import { ReportsService } from '../../../services/reports.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'payment-policy',
  templateUrl: './payment.component.html',
})
export class PaymentComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = PaymentCopy;
  numberOfRegions = new SelectQuestionModel();
  contraventions = new ContraventionQuestionModel();
  refunds = new RadioQuestionModel();
  instalments = new RadioQuestionModel();
  driverReasonSelect = new SelectQuestionModel();
  payFullPolicy = new RadioQuestionModel();

  selectedDriverReasons = [];
  stages = [];
  selectedDriverReason: object;

  chargeRegions = [];
  feeAmounts: {
    revenue: string;
    percentContested: string;
    courtFee: string;
    newCourtFee: string;
  };
  payInstructions: Array<{
    name: string;
    description: string;
  }> = [];

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService,
    private reportsService: ReportsService
  ) {}

  ngOnInit() {
    this.setNumberOfRegionsQuestion();
    this.setChargeRegions();
    this.setRefundsQuestion();
    this.setInstalmentsQuestion();
    this.setPayInstructions();
    this.setDriverReasonQuestion();
    this.setStages();
    this.setPayFullPolicyQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setNumberOfRegionsQuestion() {
    this.numberOfRegions.data = {
      title: this.textCopy.amountsSubtitle,
      answers: [
        { id: 0, value: '1' },
        { id: 1, value: '2' },
        { id: 2, value: '3' },
      ],
    };
  }

  setChargeRegions() {
    for (let regionIndex = 1; regionIndex < 4; regionIndex++) {
      this.chargeRegions.push({
        id: regionIndex,
        options: [],
      });
      for (let optionIndex = 1; optionIndex < 4; optionIndex++) {
        this.chargeRegions[regionIndex - 1].options.push({
          id: optionIndex,
          value: '',
        });
      }
    }
  }

  setContraventionsQuestion() {
    this.contraventions.options = [];
    this.contraventions.options.push({
      value: '-',
      text: '-',
    });
    const optionsAdded = [];
    for (let index = 0; index <= this.numberOfRegions.valueSelected; index++) {
      this.chargeRegions[index].options.forEach((option) => {
        if (optionsAdded.indexOf(option.value) === -1) {
          optionsAdded.push(option.value);
          this.contraventions.options.push({
            value: option.value,
            text: option.value,
          });
        }
      });
    }
    this.contraventions.options.sort((a, b) => a['value'] - b['value']);
  }
  onContraventionsSelected(answerValue) {
    this.contraventions.valuesSelected = answerValue;
    this.contraventions.valuesSelected = this.contraventions.valuesSelected.slice();
  }

  setRefundsQuestion() {
    this.refunds.data = {
      title: this.textCopy.refundsSubtitle,
      answers: [
        { text: 'send a letter saying a refund will follow', value: '0' },
        { text: 'send a letter with a refund enclosed', value: '1' },
      ],
    };
  }

  setInstalmentsQuestion() {
    this.instalments.data = {
      title: this.textCopy.instalmentsSubtitle,
      answers: [
        { text: 'yes, before the Charge Certificate has been issued', value: '0' },
        {
          text: 'yes, before bailiffs/enforcement agents/sheriffs have been instructed',
          value: '1',
        },
        { text: 'no', value: '2' },
      ],
    };
  }

  setPayInstructions() {
    for (let instructionIndex = 0; instructionIndex < 6; instructionIndex++) {
      this.payInstructions.push({ name: '', description: '' });
    }
  }

  setDriverReasonQuestion() {
    this.driverReasonSelect.data = {
      title: this.textCopy.driverReasonTitle,
      answers: [
        {
          id: 0,
          value: "I've been away so didn't know the charge was increasing - can I pay less?",
        },
        { id: 1, value: "I'm short of money - can I pay less?" },
        {
          id: 2,
          value: "I've changed address so didn't know the charge was increasing - can I pay less?",
        },
        { id: 3, value: "You didn't reply to my letter - can I pay less?" },
        {
          id: 4,
          value: "I tried to pay before the charge increased but didn't succeed - can I pay less?",
        },
        { id: 5, value: 'Can I pay less?' },
      ],
    };
  }

  setStages() {
    const options = [
      { id: 0, value: 'offer no reduced charge' },
      { id: 1, value: 'offer discount - after consulting user' },
      { id: 2, value: 'offer discount - without consulting user' },
    ];
    const extraOptions = [
      ...options,
      { id: 3, value: 'offer standard charge - after consulting user' },
      { id: 4, value: 'offer standard charge - without consulting user' },
      { id: 5, value: 'offer discount or standard charge - after consulting user' },
    ];
    const times = [
      { id: 0, value: 'for 7 days' },
      { id: 1, value: 'for 14 days' },
      { id: 2, value: 'for 21 days' },
    ];
    this.stages = [
      {
        id: 0,
        text: 'at full-charge stage - non-postal PCN:',
        options,
        times,
      },
      {
        id: 1,
        text: 'at full-charge stage - postal PCN:',
        options,
        times,
      },
      {
        id: 2,
        text: 'at NTO stage:',
        options,
        times,
      },
      {
        id: 3,
        text: 'at Charge Cert stage:',
        options: extraOptions,
        times,
      },
      {
        id: 4,
        text: 'at Order for Recovery stage:',
        options: extraOptions,
        times,
      },
    ];
  }

  changeSelectedDriverReason() {
    const selectedDriverId = parseInt(this.driverReasonSelect.valueSelected, 10);
    this.selectedDriverReason = this.selectedDriverReasons[selectedDriverId];
  }

  setPayFullPolicyQuestion() {
    this.payFullPolicy.data = {
      title: this.textCopy.otherSubtitle,
      answers: [
        {
          value: '0',
          text: 'keep the payment and tell the driver that, by paying, they no longer have the right to challenge',
        },
        {
          value: '1',
          text: 'give these drivers the same consideration as drivers who challenge without paying',
        },
      ],
    };
  }

  onRadioSelected(answer, object) {
    object.valueSelected = answer;
  }

  onSelectQuestionSelected(answer, object) {
    object.valueSelected = answer;
  }

  setSelectedValues() {
    // TODO: Fees & Charges Code
    this.numberOfRegions.valueSelected = this.policiesAnswers['18_1_0_1'];
    this.refunds.valueSelected = this.policiesAnswers['18_2'];
    this.instalments.valueSelected = this.policiesAnswers['18_3'];
    this.driverReasonSelect.valueSelected = '1';
    this.payFullPolicy.valueSelected = this.policiesAnswers['18_5_1'];

    this.setChargeRegionsSelected();
    this.setSelectedContraventions();

    this.setSelectedPayInstructions();
    this.setSelectedDriverReasons();

    this.feeAmounts = {
      revenue: this.policiesAnswers['18_1_4'],
      percentContested: this.policiesAnswers['18_1_5'],
      courtFee: this.policiesAnswers['18_1_2'],
      newCourtFee: this.policiesAnswers['18_1_2_2'],
    };
  }
  setChargeRegionsSelected() {
    // TODO: Fees & Charges Code
    this.chargeRegions = [
      {
        id: 1,
        options: [
          { id: 1, value: this.policiesAnswers['18_1_0_2_1_1'] },
          { id: 2, value: this.policiesAnswers['18_1_0_2_1_2'] },
          { id: 3, value: this.policiesAnswers['18_1_0_2_1_3'] },
        ],
      },
      {
        id: 2,
        options: [
          { id: 1, value: this.policiesAnswers['18_1_0_2_2_1'] },
          { id: 2, value: this.policiesAnswers['18_1_0_2_2_2'] },
          { id: 3, value: this.policiesAnswers['18_1_0_2_2_3'] },
        ],
      },
      {
        id: 3,
        options: [
          { id: 1, value: this.policiesAnswers['18_1_0_2_3_1'] },
          { id: 2, value: this.policiesAnswers['18_1_0_2_3_2'] },
          { id: 3, value: this.policiesAnswers['18_1_0_2_3_3'] },
        ],
      },
    ];
  }

  setSelectedContraventions() {
    this.reportsService.getOffences().subscribe((result) => {
      this.contraventions.valuesSelected = [];
      result.forEach((contravention) => {
        // no contravention 15 and 77 for policies
        if (contravention.id === 15 || contravention.id === 77) {
          return;
        }
        const value = this.policiesAnswers[`18_1_6_${contravention.id}`];
        this.contraventions.valuesSelected.push({
          id: contravention.id,
          value: value !== undefined ? value : '-',
        });
        this.setContraventionsQuestion();
      });
    });
  }

  setSelectedPayInstructions() {
    this.payInstructions[0] = {
      name: this.policiesAnswers['18_4_1_1'],
      description: this.policiesAnswers['18_4_1_2'],
    };
    this.payInstructions[1] = {
      name: this.policiesAnswers['18_4_2_1'],
      description: this.policiesAnswers['18_4_2_2'],
    };
    this.payInstructions[2] = {
      name: this.policiesAnswers['18_4_3_1'],
      description: this.policiesAnswers['18_4_3_2'],
    };
    this.payInstructions[3] = {
      name: this.policiesAnswers['18_4_4_1'],
      description: this.policiesAnswers['18_4_4_2'],
    };
    this.payInstructions[4] = {
      name: this.policiesAnswers['18_4_5_1'],
      description: this.policiesAnswers['18_4_5_2'],
    };
    this.payInstructions[5] = {
      name: this.policiesAnswers['18_4_6_1'],
      description: this.policiesAnswers['18_4_6_2'],
    };
  }

  setSelectedDriverReasons() {
    this.selectedDriverReasons = [
      {
        id: 0,
        stages: [
          {
            id: 0,
            option: this.policiesAnswers['18_6_1_1_1'],
            time: this.policiesAnswers['18_6_1_1_3'],
          },
          {
            id: 1,
            option: this.policiesAnswers['18_6_1_2_1'],
            time: this.policiesAnswers['18_6_1_2_3'],
          },
          {
            id: 2,
            option: this.policiesAnswers['18_6_1_3_1'],
            time: this.policiesAnswers['18_6_1_3_3'],
          },
          {
            id: 3,
            option: this.policiesAnswers['18_6_1_4_2'],
            time: this.policiesAnswers['18_6_1_4_3'],
          },
          {
            id: 4,
            option: this.policiesAnswers['18_6_1_5_2'],
            time: this.policiesAnswers['18_6_1_5_3'],
          },
        ],
      },
      {
        id: 1,
        stages: [
          {
            id: 0,
            option: this.policiesAnswers['18_6_2_1_1'],
            time: this.policiesAnswers['18_6_2_1_3'],
          },
          {
            id: 1,
            option: this.policiesAnswers['18_6_2_2_1'],
            time: this.policiesAnswers['18_6_2_2_3'],
          },
          {
            id: 2,
            option: this.policiesAnswers['18_6_2_3_1'],
            time: this.policiesAnswers['18_6_2_3_3'],
          },
          {
            id: 3,
            option: this.policiesAnswers['18_6_2_4_2'],
            time: this.policiesAnswers['18_6_2_4_3'],
          },
          {
            id: 4,
            option: this.policiesAnswers['18_6_2_5_2'],
            time: this.policiesAnswers['18_6_2_5_3'],
          },
        ],
      },
      {
        id: 2,
        stages: [
          {
            id: 0,
            option: this.policiesAnswers['18_6_3_1_1'],
            time: this.policiesAnswers['18_6_3_1_3'],
          },
          {
            id: 1,
            option: this.policiesAnswers['18_6_3_2_1'],
            time: this.policiesAnswers['18_6_3_2_3'],
          },
          {
            id: 2,
            option: this.policiesAnswers['18_6_3_3_1'],
            time: this.policiesAnswers['18_6_3_3_3'],
          },
          {
            id: 3,
            option: this.policiesAnswers['18_6_3_4_2'],
            time: this.policiesAnswers['18_6_3_4_3'],
          },
          {
            id: 4,
            option: this.policiesAnswers['18_6_3_5_2'],
            time: this.policiesAnswers['18_6_3_5_3'],
          },
        ],
      },
      {
        id: 3,
        stages: [
          {
            id: 0,
            option: this.policiesAnswers['18_6_4_1_1'],
            time: this.policiesAnswers['18_6_4_1_3'],
          },
          {
            id: 1,
            option: this.policiesAnswers['18_6_4_2_1'],
            time: this.policiesAnswers['18_6_4_2_3'],
          },
          {
            id: 2,
            option: this.policiesAnswers['18_6_4_3_1'],
            time: this.policiesAnswers['18_6_4_3_3'],
          },
          {
            id: 3,
            option: this.policiesAnswers['18_6_4_4_2'],
            time: this.policiesAnswers['18_6_4_4_3'],
          },
          {
            id: 4,
            option: this.policiesAnswers['18_6_4_5_2'],
            time: this.policiesAnswers['18_6_4_5_3'],
          },
        ],
      },
      {
        id: 4,
        stages: [
          {
            id: 0,
            option: this.policiesAnswers['18_6_5_1_1'],
            time: this.policiesAnswers['18_6_5_1_3'],
          },
          {
            id: 1,
            option: this.policiesAnswers['18_6_5_2_1'],
            time: this.policiesAnswers['18_6_5_2_3'],
          },
          {
            id: 2,
            option: this.policiesAnswers['18_6_5_3_1'],
            time: this.policiesAnswers['18_6_5_3_3'],
          },
          {
            id: 3,
            option: this.policiesAnswers['18_6_5_4_2'],
            time: this.policiesAnswers['18_6_5_4_3'],
          },
          {
            id: 4,
            option: this.policiesAnswers['18_6_5_5_2'],
            time: this.policiesAnswers['18_6_5_5_3'],
          },
        ],
      },
      {
        id: 5,
        stages: [
          {
            id: 0,
            option: this.policiesAnswers['18_6_6_1_1'],
            time: this.policiesAnswers['18_6_6_1_3'],
          },
          {
            id: 1,
            option: this.policiesAnswers['18_6_6_2_1'],
            time: this.policiesAnswers['18_6_6_2_3'],
          },
          {
            id: 2,
            option: this.policiesAnswers['18_6_6_3_1'],
            time: this.policiesAnswers['18_6_6_3_3'],
          },
          {
            id: 3,
            option: this.policiesAnswers['18_6_6_4_2'],
            time: this.policiesAnswers['18_6_6_4_3'],
          },
          {
            id: 4,
            option: this.policiesAnswers['18_6_6_5_2'],
            time: this.policiesAnswers['18_6_6_5_3'],
          },
        ],
      },
    ];
    this.selectedDriverReason = this.selectedDriverReasons[0];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '18_1_0_1', description: this.numberOfRegions.valueSelected },
      { id: '18_2', description: this.refunds.valueSelected },
      { id: '18_3', description: this.instalments.valueSelected },
      { id: '18_5_1', description: this.payFullPolicy.valueSelected },
      { id: '18_1_4', description: this.feeAmounts.revenue },
      { id: '18_1_5', description: this.feeAmounts.percentContested },
      { id: '18_1_2', description: this.feeAmounts.courtFee },
      { id: '18_1_2_2', description: this.feeAmounts.newCourtFee },
    ];

    this.chargeRegions.forEach((region, index) => {
      region.options.forEach((option, optIndex) => {
        policyList.push({ id: `18_1_0_2_${index + 1}_${optIndex + 1}`, description: option.value });
      });
    });
    this.contraventions.valuesSelected.forEach((contravention, index) => {
      policyList.push({ id: `18_1_6_${contravention['id']}`, description: contravention['value'] });
    });
    this.payInstructions.forEach((instruction, index) => {
      policyList.push({ id: `18_4_${index + 1}_1`, description: instruction.name });
      policyList.push({ id: `18_4_${index + 1}_2`, description: instruction.description });
    });
    let optionCatIndex = '1';
    this.selectedDriverReasons.forEach((reason, reasonIndex) => {
      reason.stages.forEach((option, optionIndex) => {
        optionCatIndex = optionIndex === 3 || optionIndex === 4 ? '2' : '1';
        policyList.push({
          id: `18_6_${reasonIndex + 1}_${optionIndex + 1}_${optionCatIndex}`,
          description: option.option,
        });
        policyList.push({
          id: `18_6_${reasonIndex + 1}_${optionIndex + 1}_3`,
          description: option.time,
        });
      });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
